import CONFIRM_DIALOGS from './confirm-dialog/el';
import ERROR_DIALOGS from "./error-dialog/el";
import RESULT_DIALOGS from "./result-dialog/el";

export default {
    BUTTONS: {
        SUBMIT: "Υποβολή",
        PREVIOUS: "Προηγούμενο",
        NEXT: "Επόμενο",
        VIEW: "Προβολή",
        UPLOAD: "Μεταφόρτωση",
        UPLOAD_FILE: "Μεταφόρτωση αρχείου",
        VIEW_FILE: "Προβολή αρχείου",
        DELETE_FILE: "Διαγραφή αρχείου",
        CLOSE: "Κλείσιμο",
        DELETE: "Διαγραφή",
        CANCEL: "Ακύρωση",
        YES: "Ναι",
        NO: "Όχι",
        OK: "Εντάξει",
        ADD: "Προσθήκη",
        UPDATE_STATUS: "Κατάσταση ενημέρωσης",
        RETURN_DASHBOARD: "Επιστροφή στον Πίνακα ελέγχου",
        REFRESH: "Ανανέωση",
        BULK_UPDATE_STATUS: "Ενημέρωση κατάστασης επιλεγμένων",
        BULK_OVERWRITE_LOCATIONS: "Αντικατάσταση τοποθεσιών",
        BULK_OVERWRITE_TYPES: "Τύποι αντικατάστασης",
        BULK_OVERWRITE_TAGS: "Αντικατάσταση ετικετών",
        BULK_ADD_LOCATIONS: "Προσθήκη τοποθεσιών",
        BULK_ADD_TYPES: "Προσθήκη τύπων",
        BULK_ADD_TAGS: "Προσθήκη ετικετών",
        BULK_UPDATE: "Μαζική ενημέρωση",
        CHARGE_THROUGH_AUTHORIZE_NET: "Χρέωση μέσω Authorize.Net",
        CHARGE_THROUGH_STRIPE: "Φόρτιση μέσω Stripe",
        INVOICE_THROUGH_STRIPE: "Τιμολόγιο μέσω Stripe",
        ADD_USER_TO_MAILCHIMP: "Προσθήκη {0} χρηστών στο Mailchimp",
        CHARGE_CLIENT_AND_PAYOUT_CANDIDATE: "Χρέωση πελάτη και υποψήφιος πληρωμής",
        BULK_COPY_SUGGESTED_CHARGE: "Προτεινόμενη χρέωση μαζικής αντιγραφής στη συνολική χρέωση πελάτη",
        BULK_DELETE: "Διαγραφή επιλεγμένων",
        BULK_UNASSIGNED: "Κατάργηση ανάθεσης επιλεγμένων",
        EXPORT_EMPLOYERS: "Εξαγωγή λίστας αλληλογραφίας πελατών",
        EXPORT_CANDIDATES: "Export Candidate Mailing List",
        UPDATE_MANAGER: "Ενημέρωση {0}",
        VIEW_PROFILE: "Προβολή προφίλ",
        VIEW_OFFER: "Προβολή προσφοράς",
        SAVE: "Αποθήκευση",
        EXPAND_ALL: "Ανάπτυξη όλων",
        COLLAPSE_ALL: "Σύμπτυξη όλων",
        SELECT_ALL: "Επιλογή όλων",
        UNSELECT_ALL: "Κατάργηση επιλογής όλων",
        RESET_FILTERS: "Επαναφορά φίλτρων",
        CLOCK_IN: "Ρολόι μέσα",
        ADD_A_BREAK: "Προσθήκη διαλείμματος",
        CLOCK_OUT: "Clock Out",
        CONFIRM_CLOCK_IN_OUT: "Επιβεβαίωση πελάτη",
        LEAVE_REVIEW: "Αφήστε μια κριτική",
        DECLINE: "Απόρριψη",
        DECLINE_WITHOUT_NOTIFICATION: "Απόρριψη χωρίς ειδοποίηση",
        UNDECLINE: "Απόρριψη",
        ACCEPT: "Αποδοχή",
        CHECK_PAYMENT: "Έλεγχος έκφρασης πληρωμής",
        CREATE_SNAPSHOT_APPLICATION_FORM: "Αποθήκευση τρέχουσας φόρμας αίτησης",
        RESTORE_APPLICATION_FORM: "Επαναφορά αποθηκευμένης έκδοσης εφαρμογής",
        RETURNING_APPLICANT: "Είμαι υποψήφιος που επιστρέφει",
        AAASSIGN: "Ανάθεση",
        TENTATIVELY_ASSIGN: "Προσωπικά εκχώρηση",
        SIGN: "Sign",
        EDIT: "Επεξεργασία",
        DUPLICATE: "Διπλότυπο",
        ADD_ADDITIONAL_DATES: "Προσθήκη πρόσθετων ημερομηνιών",
        ADD_A_BOOKING: "Προσθήκη κράτησης",
        ADD_A_GROUP: "Προσθήκη ομάδας",
        MESSAGE: "Μήνυμα",
        UPDATE_CUSTOM_STATUS: "Ενημέρωση κατάστασης {0}",
        UPDATE: "Ενημέρωση",
        ADD_OPTION: "Προσθήκη επιλογής",
        EDIT_SETTING: "Επεξεργασία ρυθμίσεων",
        AADONE: "Τέλος",
        SUBMIT_REPORT: "Υποβολή αναφοράς",
        REVIEW_REPORT_BUTTON: "Προβολή προβλημάτων που έχουν αναφερθεί",
        SEARCH_CANDIDATES_FOR_ALL_BOOKING: "Αναζήτηση για υποψήφιους διαθέσιμους για όλες τις ανοιχτές κρατήσεις",
        SHARE_WITH_MARKET_PLACE: "Κοινή χρήση με το Agency Marketplace",
        CUSTOMIZE_TEMPLATE: "Προσαρμογή προτύπου"
    },
    PLACE_HOLDERS: {
        NEW_STATUS: "Νέα κατάσταση",
        NEW_LOCATIONS: "Νέες τοποθεσίες",
        NEW_TYPES: "Νέοι τύποι",
        NEW_TAGS: "Νέες ετικέτες",
        FILTER_BY_STATUS: "Φιλτράρισμα κατά κατάσταση",
        FILTER_BY_STATUSES: "Φιλτράρισμα κατά καταστάσεις",
        FILTER_BY: "Φιλτράρισμα κατά {0}",
        STATUSES_TO_HIDE: "Καταστάσεις προς απόκρυψη",
        FILTER_BY_LOCATIONS: "Φιλτράρισμα κατά τοποθεσίες",
        FILTER_BY_DURATIONS: "Φιλτράρισμα κατά Διάρκεια",
        FILTER_BY_ROLES: "Φιλτράρισμα κατά ρόλους",
        FILTER_BY_TYPES: "Φιλτράρισμα κατά τύπους",
        FILTER_BY_TAGS: "Φιλτράρισμα κατά ετικέτες",
        FILTER_BY_MANAGER: "Φιλτράρισμα κατά διαχειριστή",
        FILTER_BY_CLIENT: "Φίλτρο ανά πελάτη",
        FILTER_BY_CATEGORIES: "Φιλτράρισμα κατά κατηγορίες",
        FILTER_BY_START_DATE: "Φιλτράρισμα κατά ημερομηνία έναρξης",
        FILTER_BY_END_DATE: "Φιλτράρισμα κατά ημερομηνία λήξης",
        FILTER_BY_WEEK_DAY: "Φιλτράρισμα ανά εβδομάδα ημέρας",
        FILTER_BY_CLIENTS: "Φιλτράρισμα κατά πελάτες",
        FILTER_BY_CLIENT_STATUSES: "Filter by Client Statuses",
        FILTER_BY_CLIENT_TYPES: "Φιλτράρισμα κατά τύπους πελατών",
        FILTER_BY_CANDIDATES: "Φίλτρο κατά υποψήφιο(ους)",
        FILTER_BY_JOB_TYPES: "Φιλτράρισμα κατά τύπους εργασίας",
        FILTER_BY_JOB_STATUSES: "Φιλτράρισμα κατά καταστάσεις εργασίας",
        FILTER_BY_JOB_ID: "Φιλτράρισμα κατά αναγνωριστικό εργασίας",
        SELECT_SCRAPER_ACCOUNTS: "Select Scraper Accounts",
        FILTER_BY_USER_TYPE: "Φιλτράρισμα κατά τύπο χρήστη",
        KEYWORD_SEARCH_USER_PROFILE: "Αναζήτηση λέξης-κλειδιού/φράσης οπουδήποτε στο προφίλ χρήστη, πατήστε Enter για εφαρμογή αναζήτησης",
        SEARCH_BY_NAME_EMAIL_PHONE: "Αναζήτηση κατά όνομα, email ή αριθμό τηλεφώνου",
        FILTER_BY_RECENT_ACTIVE: "Filter by Recently Active",
        SELECT_LOCATIONS: "Επιλογή τοποθεσιών",
        SELECT_OPTION: "Επιλογή επιλογής",
        SELECT_CLIENT: "Επιλογή πελάτη",
        SELECT_CANDIDATE: "Επιλέξτε υποψήφιο",
        SELECT_CANDIDATES: "Επιλογή υποψηφίων",
        SELECT_CANDIDATE_SEARCHABLE: "Επιλέξτε υποψήφιο (Τύπος για αναζήτηση)",
        SELECT_ADMINS: "Επιλογή διαχειριστών",
        SELECT_ADMIN_RECEIVE_EMAIL: "Επιλέξτε διαχειριστές που λαμβάνουν μηνύματα ηλεκτρονικού ταχυδρομείου",
        SELECT_STATUS: "Επιλογή κατάστασης",
        SELECT_LANGUAGES: "Επιλογή γλωσσών",
        SELECT_TYPES: "Επιλέξτε τύπους",
        SELECT_TYPE: "Επιλέξτε τύπο",
        SELECT_AUDIENCE: "Επιλογή κοινού",
        SELECT_TAGS: "Επιλογή ετικετών",
        SELECT_USER_TYPE: "Επιλογή τύπου χρήστη",
        SELECT_USER_TYPES: "Επιλογή τύπων χρηστών",
        SELECT_CATEGORY: "Επιλογή κατηγορίας",
        SELECT_CATEGORY_ADMIN_ONLY: "Επιλογή κατηγορίας (Μόνο διαχειριστής)",
        SELECT_TRIGGER: "Επιλογή ενεργοποίησης",
        SELECT_ONE: "Επιλέξτε ένα",
        SELECT_PROFILE_BUILDER: "Επιλέξτε το πρόγραμμα δημιουργίας προφίλ",
        SELECT_TIME_OFF_CATEOGRY: "Επιλογή κατηγορίας χρόνου απενεργοποίησης",
        SELECT_DESTINATION: "Επιλογή προορισμού",
        SELECT_ACCESS_LEVEL: "Επιλογή επιπέδου πρόσβασης",
        SELECT_VISIBILITY_SCOPE: "Επιλογή εύρους ορατότητας",
        SELECT_AREAS: "Επιλογή Περιοχών",
        NUMBER: "Αριθμός",
        DESCRIPTION_CHARGE: "Περιγραφή χρέωσης (αυτή η περιγραφή θα περιλαμβάνεται στην απόδειξη του χρήστη)",
    },
    LABELS: {
        SELECT_TEMPLATE: "Επιλογή προτύπου",
        SELECT_ANALYTICS_DASHBOARD_FIELDS: "Επιλογή πεδίων για αναλυτικά στοιχεία",
        FILTER_BY_LOCATIONS: "Φιλτράρισμα κατά τοποθεσίες",
        FILTER_BY_TYPES: "Φιλτράρισμα κατά τύπους",
        FILTER_BY_MANAGER: "Φιλτράρισμα κατά διαχειριστή",
        FILTER_BY_CLIENT: "Φίλτρο ανά πελάτη",
        FILTER_BY_CATEGORIES: "Φιλτράρισμα κατά κατηγορίες",
        FILTER_BY_STATUS: "Φιλτράρισμα κατά κατάσταση",
        ADDRESS: "Διεύθυνση",
        CITY: "Πόλη",
        AASTATE: "Πολιτεία",
        COUNTRY: "Χώρα",
        ZIP_CODE: "Ταχυδρομικός κώδικας",
        LOCATIONS: "Τοποθεσίες",
        DESCRIPTION: "Περιγραφή",
        PER_HOUR: "ανά ώρα",
        ADD_ITEM: "Προσθήκη {0}",
        EDIT_ITEM: "Επεξεργασία {0}",
        SAVE_AND_ADD_ANOTHER_ITEM: "Αποθήκευση και προσθήκη άλλου {0}",
        WELCOME_TEXT: "Καλώς ήρθατε στο {0}"
    },
    HEADERS: {
        EMAIL_LOG: "Αρχείο ηλεκτρονικού ταχυδρομείου",
        SMS_LOG: "Αρχείο SMS"
    },
    LINK_TEXT: {
        HIDE_STATUS_BY_DEFAULT: "Πώς να αποκρύψετε τις καταστάσεις από προεπιλογή",
        HOW_TO_CHANGE_STATUS: "Πώς να προσθέσετε/αλλάξετε καταστάσεις"
    },
    DESCRIPTIONS: {
        SEPARATE_MULTIPLE_EMAIL: "Διαχωρίστε πολλαπλά μηνύματα ηλεκτρονικού ταχυδρομείου με ; (π.χ.: nanny1@hotmail.com; nanny2@hotmail.com )",
        SMS_NOTE: `Λάβετε υπόψη ότι υπάρχει κόστος 0,0115 $ (1,15¢) ανά 160 χαρακτήρες των απεσταλμένων/ληφθέντων SMS.`,
        SMS_COUNTER_NOTE: "Ο ακριβής αριθμός χαρακτήρων θα εξαρτηθεί από τις πληροφορίες που εισάγονται στο πραγματικό μήνυμα.",
        CLIENT_NOT_ENTERED_STRIPE: "Ο πελάτης δεν έχει εισαγάγει πληροφορίες Stripe.",
        CLIENT_NOT_ENTERED_AUTHORIZE_NET: "Ο πελάτης δεν έχει καταχωρίσει πληροφορίες Authorize.Net.",
        CANDIDATE_NOT_ENTERED_STRIPE: "Ο υποψήφιος δεν έχει εισαγάγει πληροφορίες Stripe.",
        INTERVIEW_PANEL: `Σημείωση: Αυτές οι σημειώσεις προορίζονται μόνο για εσωτερική χρήση διαχειριστή και δεν είναι
         κοινόχρηστο με υποψήφιους ή πελάτες.`,
        CANDIDATE_SHAREABLE_LINK: `Αυτός είναι ένας σύνδεσμος με δυνατότητα κοινής χρήσης του προφίλ υποψηφίου. Αν θέλεις
         για να δείτε τι θα δει ένας πελάτης, <strong>βεβαιωθείτε ότι έχετε αποσυνδεθεί</strong> και στη συνέχεια
         δείτε τον σύνδεσμο (ή ανοίξτε τον σε διαφορετικό πρόγραμμα περιήγησης). Αυτός <strong>δεν</strong> είναι σύνδεσμος με τον οποίο μπορεί να συνδεθεί ο υποψήφιος σας. <a href="https://youtu.be/WXjyLdF12O0" target="_blank">Μάθετε περισσότερα.</a>`,
        CLIENT_SHAREABLE_LINK: `Αυτός είναι ένας σύνδεσμος με δυνατότητα κοινής χρήσης του προφίλ πελάτη. Αν θέλεις
         δείτε τι θα δει ένας υποψήφιος, <strong>βεβαιωθείτε ότι έχετε αποσυνδεθεί</strong> και μετά
         δείτε τον σύνδεσμο (ή ανοίξτε τον σε διαφορετικό πρόγραμμα περιήγησης). Αυτός <strong>δεν</strong> είναι σύνδεσμος με τον οποίο μπορούν να συνδεθούν οι πελάτες σας. <a href="https://youtu.be/WXjyLdF12O0" target="_blank">Μάθετε περισσότερα.</a>`,
        CLIENT_PUBLIC_PAYMENT_LINK: `Αυτός είναι ένας δημόσιος σύνδεσμος πληρωμής. Ο πελάτης μπορεί να έχει πρόσβαση σε αυτόν τον σύνδεσμο για να εισαγάγει στοιχεία πληρωμής χωρίς να συνδεθεί`,
        TYPE_YOUR_NAME_TO_SIGN: 'Πληκτρολογήστε το όνομά σας για υπογραφή (συμφωνείτε ότι αυτό ισοδυναμεί με την υπογραφή ενός φυσικού εγγράφου)',
        JOB_BOARD_ADMIN_VIEW_WARNING: "Βλέπετε αυτόν τον πίνακα εργασιών ως διαχειριστής. Εάν θέλετε να το δείτε από την οπτική γωνία ενός υποψηφίου, ανοίξτε το σε διαφορετικό παράθυρο προγράμματος περιήγησης ή ανώνυμης περιήγησης. Εάν χρειάζεστε βοήθεια για την ενσωμάτωση αυτού στον ιστότοπό σας, επικοινωνήστε μαζί μας!"
    },
    TABLE_HEADERS: {
        ACTIONS: "Ενέργειες",
        NOTES: "Σημειώσεις",
        VALUE: "Αξία",
        EFFECTIVE_FROM: "Εφαρμόζεται από",
        EFFECTIVE_UNTIL: "Ισχύει μέχρι",
        TYPE: "Τύπος",
        CATEGORIES: "Κατηγορίες"
    },
    OPTIONS: {
        "YES": "Ναι",
        "NO": "Όχι"
    },
    ERROR_ΜΗΝΥΜΑΤΑ: {
        FIELD_REQUIRED: "Αυτό το πεδίο είναι υποχρεωτικό."
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "Ευχαριστώ!",
        STEP_OF: "Βήμα {0} από {1}"
    },
    REFERENCE_CHECK_FORM: {
        FILL_THE_FORM_REQUEST: "Βοηθήστε μας να συμπληρώσουμε την παρακάτω φόρμα",
        REFERENCE_FOR: "Reference for {0} {1}",
        REFERENCE_INPUT_BY: "Πληροφορίες αναφοράς που εισάγονται από τον χρήστη {0} {1}",
        FORM_SUBMITTED: "Η φόρμα ελέγχου αναφοράς έχει υποβληθεί!"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Αποθέστε ένα αρχείο εδώ ή κάντε κλικ για μεταφόρτωση",
        MAXIMUM_UPLOAD_SIZE: "Μέγιστο μέγεθος μεταφόρτωσης {0}MB",
        FILE_EXCEED_MAXIMUM: "Το μέγεθος αρχείου υπερβαίνει τα {0}MB.",
        FILE: "Αρχείο"
    },
    BOOKING_SECTION: {
        LABEL: {
            BOOKINGS: "Κρατήσεις",
            HIDE_PAST_BOOKINGS: "Απόκρυψη προηγούμενων κρατήσεων",
            BOOKING_CREDIT_LEFT: "Απομένουν {0} πιστώσεις κράτησης",
            MIN_BOOKINGS_REQUIRE: "Χρειάζεστε τουλάχιστον {0} κράτηση!",
            SELECTED_CANDIDATE: "Επιλεγμένος υποψήφιος",
            TOTAL_BOOKING_FEE: "Συνολική χρέωση κράτησης",
            BOOKING_GROUPS: "Ομάδες κρατήσεων"
        },
        DESCRIPTION: {
            CLICK_ON_BOOKING: "Κάντε κλικ στην κράτηση (στο ημερολόγιο) για να μάθετε περισσότερα σχετικά με τον παροχέα υπηρεσιών που σας έχει ανατεθεί και να αφήσετε μια κριτική.",
            CLICK_ON_DATE: "Παρακαλώ κάντε κλικ σε μια ημερομηνία για να προσθέσετε μια κράτηση.",
            CLICK_ON_OTHER_DATE: "Παρακαλώ κάντε κλικ σε άλλη ημερομηνία στο ημερολόγιο για να προσθέσετε μια κράτηση.",
            BOOKING_GROUP: "Όλες οι κρατήσεις στην ίδια ομάδα πρέπει να ανατεθούν σε έναν εκδοχέα"
        },
        PRICES: {
            BOOKING_RATE: "Ποσοστό κράτησης",
            BOOKING_FEE: "Χρέωση κράτησης",
            PER_BOOKING_FEE: "Ανά κράτηση",
            CLIENT_RATE: "Ποσοστό πελάτη",
            CANDIDATE_RATE: "Ποσοστό υποψηφίου",
            AGENCY_FEE: "Χρέωση πρακτορείου",
            TRAVEL_FEE: "Τέλη ταξιδιού",
            RUSH_FEE: "Χρέωση αιχμής",
            CANDIDATE_RUSH_FEE: "Τέλος βιασύνης υποψηφίου",
            PER_BOOKING_AGENCY_FEE: "Χρέωση πρακτορείου ανά κράτηση",
            PER_BOOKING_CANDIDATE_FEE: "Τέλη ανά κράτηση υποψηφίου",
            ADMIN_FEE: "Χρέωση διαχειριστή",
            ADMIN_PERCENTAGE: "Ποσοστό διαχειριστή",
            ADDITIONAL_FEES: "Πρόσθετες χρεώσεις"
        }
    },
    BOOKING_DIALOG: {
        LABEL: {
            ADDITIONAL_DATES: "Προσθήκη πρόσθετων ημερομηνιών",
            START_TIME: "Ώρα έναρξης",
            END_TIME: "Ώρα λήξης",
            END_DATE: "Ημερομηνία λήξης",
            SELECT_CLIENT: "Επιλογή πελάτη",
            ASSIGNED_CANDIDATE: "Θέλετε να αναθέσετε αυτήν την εργασία;",
            TENTATIVELY_ASSIGN_CANDIDATE: "Θέλετε να αναθέσετε προσωρινά αυτήν την εργασία;",
            REPEAT: "Θέλετε αυτήν την υπηρεσία περισσότερες από μία φορές (επαναλαμβανόμενη/επαναλαμβανόμενη);",
            REPEAT_UNTIL: "Επανάληψη μέχρι",
            REPEAT_EVERY: "Επανάληψη κάθε",
            REPEAT_ON: "Επανάληψη ενεργό",
            BOOKING_ADDRESS: "Διεύθυνση κράτησης",
            ADDRESS_LINE2: "Γραμμή διεύθυνσης 2",
            CITY: "Πόλη",
            STATE: "Πολιτεία/Επαρχία",
            ZIP_CODE: "Ταχυδρομικός κώδικας",
            NUMBER_CHILDREN: "Πόσα παιδιά θα φροντίσουν;",
            SELECT_JOB_CATEGORY: "Επιλέξτε κατηγορία εργασίας",
            SELECT_DATE: "Ημερομηνία κράτησης",
            SELECT_SERVICE: "Επιλογή υπηρεσίας",
            SELECT_QUICKBOOKS_PRICE: "Επιλογή τιμής",
            NUMBER_CANDIDATE: "Αριθμός {0} που χρειάζονται",
            SELECT_STATUS: "Επιλογή κατάστασης κράτησης",
            CHECK_EXISTING: "Έλεγχος για υπάρχοντα",
            INVALID_BOOKING_DURATION: "Η κράτηση πρέπει να είναι τουλάχιστον {0} ώρες"
        },
        OPTIONS: {
            REPEAT_TYPE: ["Ημέρες", "Εβδομάδες"],
            REPEAT_ON: [
                "Δευτέρα",
                "Τρίτη",
                "Τετάρτη",
                "Πέμπτη",
                "Παρασκευή",
                "Σάββατο",
                "Κυριακή"
            ]
        }
    },
    MENU_BAR: {
        TOP: {
            COMMUNITY: "Κοινότητα",
            CANDIDATE_COMMUNITY: "Υποψήφια Κοινότητα",
            MARKETPLACE: "Marketplace",
            MESSAGES: "Μηνύματα",
            SMS: "SMS",
            JOBS: "Δουλειές",
            LOGOUT: "Αποσύνδεση",
            DASHBOARD: "Ο πίνακας ελέγχου μου"
        },
        ADMIN: {
            USERS: {
                ROOT: "Χρήστες",
                CLIENTS: "Πελάτες",
                CANDIDATES: "Υποψήφιοι",
                ADMINISTRATORS: "Διαχειριστές"
            },
            JOBS_EVENTS: {
                ROOT: "Εργασίες και Ημερολόγιο",
                SHIFT_JOB_CALENDAR: "Shift Job Calendar",
                PLACEMENT_JOBS: "Εργασίες τοποθέτησης",
                PERSONAL_TO_DO: "Personal To Do"

            },
            TEMPLATES: {
                ROOT: "Πρότυπα",
                EMAIL: "Πρότυπα email",
                SMS: "Πρότυπα SMS",
                DOCUMENT: "Πρότυπα εγγράφων",
                NOTE: "Πρότυπα σημειώσεων",
                TASK: "Πρότυπα εργασιών",
                PROFILE: "Πρότυπα προφίλ",
                PUSH_NOTIFICATION: "Πρότυπα ειδοποιήσεων Push"
            },
            SETTINGS: {
                ROOT: "Ρυθμίσεις",
                AGENCY: "Ρυθμίσεις πρακτορείου",
                ADMIN: "Ρυθμίσεις διαχειριστή"
            },
            BUILDERS: {
                AAROOT: "Builders",
                PROFILE: "Application & Profile Builder",
                EVALUATION: "Evaluation Builder"
            },
            LOGS: {
                ROOT: "Καταγραφή",
                COMMUNICATION_LOG: "Αρχείο επικοινωνίας",
                STATUS_CHANGES: "Αλλαγές κατάστασης",
                ACTIVITY_LOG: "Αρχείο καταγραφής δραστηριότητας",
                APPLICATION_LOG: "Αρχείο καταγραφής εφαρμογής",
                PAYMENT_LOG: "Αρχείο πληρωμών",
                USER_MESSAGES_LOG: "Αρχείο συνομιλίας χρήστη",
            },
            OTHERS: {
                AAROOT: "Άλλα",
                RESOURCE_MANAGER: "Διαχειριστής πόρων",
                REFERENCES: "Αναφορές",
                DOCUMENTS: "Documents",
                EMAIL_BLASTER: "Email Blaster",
                NOTIFICATION_CENTER: "Κέντρο ειδοποιήσεων",
                SNAPSHOT: "Μετρήσεις και ανάλυση (στιγμιότυπο)",
                COMMUNITY: "Κοινότητα",
                DAILY_RESOURCE_MANAGER: "Daily Resource Manager",
                GLOBAL_PREDEFINED_VALUES: "Συνολικές προκαθορισμένες τιμές",
                BENEFIT_MANAGER: "Benefit Manager",
                BENEFITS: "Πλεονεκτήματα",
                TRASH: "Κάδος απορριμμάτων"
            }

        },
        CANDIDATES: {
            MY_PROFILE: "Το προφίλ μου",
            AVAILABLE_JOBS: "Διαθέσιμες εργασίες",
            MY_SCHEDULE: "Το πρόγραμμά μου",
            MY_JOBS: "Οι δουλειές μου",
            MY_FAMILIES: "Οι οικογένειές μου",
            BENEFITS: "Πλεονεκτήματα"
        },
        ADMIN_PANEL: {
            LISTS: "Λίστες",
            NOTES: "Σημειώσεις",
            EMAIL_SMS: "Email/SMS",
            EVENT: "Προγραμματισμός εκδήλωσης",
            PASSWORD: "Κωδικός πρόσβασης",
            PAYMENTS: "Πληρωμές",
            PAYMENTS_CREDIT: "Πληρωμές/Πιστώσεις",
            DOCUMENTS: "Documents",
            EVALUATIONS: "Αξιολογήσεις",
            RELATIONSHIPS: "Ανατεθέντες υποψήφιοι"
        },
        ADMIN_PANEL_SHORT: {
            EMAIL_SMS: "Email/SMS",
            EVENT: "Εκδήλωση",
            PASSWORD: "Pass",
            DOCUMENTS: "Έγγραφα",
            EVALUATIONS: "Evals",
            PAYMENTS: "$$$",
            RELATIONSHIPS: "Assign Cands"
        }
    },
    NAV_BAR: {
        TOP: "Κορυφαία",
        CHECKLIST: "Λίστα ελέγχου",
        DOCUMENTS: "Documents",
        PHOTO_GALARY: "Photo Gallery",
        INTRODUCTION_VIDEO: "Introduction Video"
    },
    ENGINEWHO: {
        PROFILE_BUILDER: {
            BASIC: "Βασικά στοιχεία του προγράμματος δημιουργίας προφίλ",
            REQUIRE_FIELD: "Πώς να επισημάνετε ερωτήσεις/πεδίο ως απαιτούμενο ή όχι",
            NOTIFICATION_DESTINATION: "Επεξεργασία Ποιος ειδοποιείται για νέους αιτούντες",
            EDIT_APPLICATION: "Πώς να επεξεργαστείτε φόρμες αιτήσεων πιο εύκολα",
            ADD_SECTION_QUESTION: "Πώς να προσθέσετε μια ερώτηση σε μια ενότητα",
            ADD_CONFIRMATION_BOX: "Πώς να προσθέσετε πεδία επιβεβαίωσης σε φόρμες αίτησης πελάτη ή υποψηφίου"
        },
        EVALUATION_BUILDER: {
            GETTING_STARTED: "Ξεκινώντας με τις αξιολογήσεις"
        },
        EMAIL_TEMPLATES: {
            GETTING_STARTED: "Ξεκινώντας με τα πρότυπα ηλεκτρονικού ταχυδρομείου",
            DEFAULT_EMAIL_FOOTER: "Ρύθμιση του προεπιλεγμένου υποσέλιδου ηλεκτρονικού ταχυδρομείου"
        },
        DOCUMENT_TEMPLATES: {
            GETTING_STARTED: "Ξεκινώντας με τα πρότυπα εγγράφων",
            NOTIFICATION_WHEN_SIGNED: "Προσθήκη ειδοποίησης όταν υπογράφεται το έγγραφο",
            ADD_DOCUMENT: "Μη αυτόματη προσθήκη εγγράφου σε χρήστη"
        },
        AGENCY: {
            STATUSES_CHECKLISTS_TYPES: "Χαρτογράφηση της διαδικασίας σας μέσω καταστάσεων, λιστών ελέγχου και τύπων",
            AGENCY_BRANDING_SETUP: "Ρύθμιση επωνυμίας εταιρείας (λογότυπο, χρώματα, γραμματοσειρές)",
            PROFILE_COMPLETE_SETUP: 'Πώς να προσθέσετε ένα κουμπί "Το προφίλ μου είναι πλήρες" Οι υποψήφιοι μπορούν να κάνουν κλικ για να σας ειδοποιήσουν ότι έχουν ολοκληρώσει το προφίλ τους',
            CONFIGURE_MULTIPLE_LOCATIONS: "Διαμόρφωση της εταιρείας σας ώστε να εξυπηρετεί πολλές διακριτές τοποθεσίες"
        },
        EMAIL_BLASTER: {
            HOW_TO: "Πώς λειτουργούν οι εκρήξεις email"
        },
        CLIENTS: {
            SHARE_CANDIDATE_PROFILE: "Πώς να μοιραστείτε το προφίλ ενός υποψηφίου με έναν πελάτη"
        }
    },
    ADMIN_DASHBOARD: {
        WELCOME_HEADER: "Καλώς ήρθατε στο Έλεγχος αποστολής {0}",
        PRO_TIP: {
            HEADER: "Δείτε τι νέο υπάρχει:",
            TEXT: "Μαζική μετάδοση εργασιών με βάρδιες!"
        },
        PLACE_HOLDERS: {
            ORDER_CLIENTS_BY: "Παραγγελία πελατών από",
            ORDER_CANDIDATES_BY: "Παραγγελία υποψηφίων κατά"
        },
        BUTTONS: {
            ADD_CLIENT: "Προσθήκη πελάτη",
            ADD_CANDIDATE: "Προσθήκη υποψηφίου",
        },
    },
    ADD_USER_DIALOG: {
        HEADER: "Προσθήκη νέου χρήστη",
        DESCRIPTION: `Αυτός είναι ένας μηχανισμός για τη μη αυτόματη προσθήκη ενός χρήστη στη βάση δεδομένων σας. Ένας χρήστης
         Το addded με αυτόν τον τρόπο θα τεθεί στην κατάσταση "Pre Application".
         (που σημαίνει ότι δεν έχουν συμπληρώσει ακόμη μια αίτηση). Ένας χρήστης σε
         αυτή η κατάσταση μπορεί ακόμα να σταλεί για τη συμπλήρωση της φόρμας αίτησης. Αν εσύ
         would να στείλει αυτόματα ένα email στους χρήστες που έχουν προστεθεί με αυτόν τον τρόπο, εσείς
         μπορεί να προσθέσει ένα πρότυπο email που είναι μια "Ειδοποίηση αλλαγής κατάστασης"
         triggering σε μια αλλαγή σε "Προ Εφαρμογή".`,
        LABELS: {
            EMAIL: "Email",
            PHONE: "Αριθμός τηλεφώνου",
            FIRST_NAME: "Όνομα",
            LAST_NAME: "Επώνυμο",
            PROFILE_BUILDER: "Profile Builder",
            USER_TYPES: "Τύποι χρηστών",
            LOCATIONS: "Τοποθεσίες",
        }
    },
    STRIPE: {
        CONNECTED_SUCCESS: "Ο λογαριασμός σας συνδέθηκε επιτυχώς με το Stripe.",
        FAILED_TO_CONECT: "Παρουσιάστηκε πρόβλημα με τη σύνδεση του λογαριασμού σας με το Stripe, δοκιμάστε ξανά ή επικοινωνήστε με την Enginehire.",
        MISSING_INFO: "Ο λογαριασμός σας έχει συνδεθεί, αλλά λείπουν πληροφορίες από την εφαρμογή Stripe, κάντε κλικ στο κουμπί σύνδεση με τη λωρίδα για να συνεχίσετε από εκεί που σταματήσατε",
    },
    DATA_TABLE: {
        SHOW: "Εμφάνιση",
        ITEMS_PER_PAGE: "στοιχεία ανά σελίδα",
        SHOWING_RANGE: "Εμφάνιση {0} έως {1} από {2} καταχωρήσεις"
    },
    EMPLOYER_DIALOG: {
        TABS: {
            ADMIN: "Διαχειριστής",
            PROFILE: "Προφίλ",
            INTAKE_NOTES: "Σημειώσεις εισαγωγής",
            COMMUNICATION_LOG: "Αρχείο επικοινωνίας",
            RECORDS: "Records",
            JOBS: "Δουλειές",
            INTAKE_NOTES_MOBILE: "Σημειώσεις",
            COMMUNICATION_LOG_MOBILE: "Com Log"
        },
        INTERVIEW_TABS: {
            PROFILE: "Προφίλ",
            AANOTES: "Σημειώσεις"
        },
        BUTTONS: {
            DELETE_CLIENT: "Διαγραφή πελάτη"
        },
    },
    CANDIDATE_DIALOG: {
        TABS: {
            ADMIN: "Διαχειριστής",
            PROFILE: "Προφίλ",
            INTERVIEW: "Συνέντευξη",
            COMMUNICATION_LOG: "Αρχείο επικοινωνίας",
            RECORDS: "Records",
            COMMUNICATION_LOG_MOBILE: "Com Log"
        },
        INTERVIEW_TABS: {
            PROFILE: "Προφίλ",
            INTERVIEW: "Συνέντευξη"
        },
        BUTTONS: {
            DELETE_CANDIDATE: "Διαγραφή υποψηφίου"
        }
    },
    ADMIN_PANEL: {
        TYPES: {
            TITLE: "Τύποι",
            BUTTON: "Αποθήκευση τύπων"
        },
        CHECKLIST: {
            TITLE: "Λίστα ελέγχου",
            BUTTON: "Αποθήκευση λίστας ελέγχου"
        },
        TAGS: {
            TITLE: "Ετικέτες",
            BUTTON: "Αποθήκευση ετικετών"
        },
        ΑΑΑΑΑΑΑΑΑΑΑΑΑ_ΤΟΠΟΘΕΣΙΕΣ: {
            TITLE: "Τοποθεσίες",
            BUTTON: "Αποθήκευση τοποθεσιών"
        },
        LANGUAGE: {
            TITLE: "Γλώσσα",
            BUTTON: "Αποθήκευση γλώσσας"
        },
        SET_PROFILE_BUILDER: {
            TITLE: "Τύπος προφίλ",
            BUTTON: "Ενημέρωση προγράμματος δημιουργίας προφίλ"
        },
        NOTES: {
            TITLE: "Σημειώσεις",
            DESCRIPTION: "Οι σημειώσεις που λαμβάνονται εδώ προορίζονται μόνο για εσωτερική χρήση διαχειριστή, δεν είναι ορατές στους χρήστες.",
            BUTTON: "Προσθήκη Σημείωσης"
        },
        AAEMAIL: {
            TITLE: "Αποστολή email",
            BUTTON_SEND: "Αποστολή",
            BUTTON_LOAD: "Φόρτωση",
            SELECT_TEMPLATE: "Επιλογή προτύπου",
            FROM_EMAIL: "Από email",
            REPLY_TO: "Απάντηση σε",
            SUBJECT: "Θέμα"
        },
        SMS: {
            TITLE: "Αποστολή SMS",
            BUTTON: "Αποστολή"
        },
        RESET_PASSWORD: {
            DESCRIPTION: "Μπορείτε να επαναφέρετε μη αυτόματα τον κωδικό πρόσβασης του χρήστη εδώ",
            BUTTON: "Ενημέρωση κωδικού πρόσβασης"
        },
        EVENT: {
            TITLE: "Προγραμματισμός εκδήλωσης (Συνέντευξη, Συνάντηση, κ.λπ.)",
            DESCRIPTION: "Αυτά τα συμβάντα θα εμφανιστούν στον πίνακα ελέγχου του χρήστη.",
            EVENT_TITLE: "Τίτλος εκδήλωσης",
            EVENT_DATE: "Ημερομηνία εκδήλωσης",
            EVENT_TIME: "Ώρα εκδήλωσης",
            INTERVIEW_LINK: "Σύνδεσμος συνέντευξης",
            INTERVIEW_LINK_PLACE_HOLDER: "Σύνδεσμος ζουμ ή άλλος σύνδεσμος κλήσης",
            NOTES: "Σημειώσεις",
            STATUS_UPDATE_TO: "{0} για ενημέρωση χρήστη σε",
            SEND_EMAIL_NOTIFICATION: "Αποστολή ειδοποίησης μέσω email για προγραμματισμένη εκδήλωση",
            ADD_TO_CALENDAR: "Προσθήκη στο Personal To Do Calendar",
            BUTTON: "Προγραμματισμός εκδήλωσης"
        },
        CREDIT: {
            TITLE: "Credits",
            BUTTON_ADD: "Προσθήκη πίστωσης",
            BUTTON_EDIT: "Επεξεργασία",
            EDIT_CREDIT_TITLE: "Επεξεργασία πίστωσης",
            ADD_CREDIT_TITLE: "Προσθήκη πίστωσης",
            PLACE_HOLDERS: {
                VALUE: "Αξία",
                AANOTES: "Σημειώσεις"
            }
        },
        STRIPE: {
            BILL_CLIENT: "Μπορείτε να χρεώνετε με μη αυτόματο τρόπο πελάτες μέσω Stripe εδώ",
            SEND_INVOICE: "Μπορείτε να στείλετε με μη αυτόματο τρόπο τιμολόγια Stripe εδώ",
            BUTTON_CHARGE: "Φόρτιση μέσω Stripe",
            BUTTON_RESET: "Επαναφορά πληροφοριών λωρίδας",
            BUTTON_INVOICE: "Τιμολόγιο μέσω Stripe",
            PAYMENT_LOGS: "Αρχεία καταγραφής πληρωμών"
        },
        AUTHORIZE_NET: {
            BILL_CLIENT: "Μπορείτε να χρεώνετε μη αυτόματα πελάτες μέσω του Authorize.Net εδώ",
            SEND_INVOICE: "Μπορείτε να στείλετε μη αυτόματα τιμολόγια Authorize.Net εδώ",
            BUTTON_CHARGE: "Φόρτιση μέσω Authorize.Net",
            BUTTON_RESET: "Επαναφορά πληροφοριών Authorize.Net",
            BUTTON_INVOICE: "Τιμολόγιο μέσω Authorize.Net",
            PAYMENT_LOGS: "Αρχεία καταγραφής πληρωμών"
        },
        REVIEW: {
            TITLE: "Κριτικές",
            RATING: "Βαθμολογία",
            AVERAGE_RATING: "Μέση βαθμολογία",
            NO_DATA: "Δεν υπάρχουν ακόμη κριτικές."
        },
        ADD_DOCUMENT: {
            TITLE: "Προσθήκη εγγράφου",
            DESCRIPTION: `Μπορείτε να προσθέσετε οποιοδήποτε Πρότυπο εγγράφου στον χρήστη από εδώ, απλώς επιλέξτε ένα
            των εγγράφων σας από το αναπτυσσόμενο μενού:`,
            BUTTON: "Προσθήκη εγγράφου",
        },
        ADD_EVALUATION: {
            BUTTON: "Προσθήκη αξιολόγησης",
        },
        RELATIONSHIP: {
            ΑΑΑΑΑΑΑΑΑΑΑΑ_ΥΠΟΨΗΦΙΟΣ: {
                TITLE: "Ανατεθέντες υποψήφιοι",
                NO_CANDIDATE: "Κανένας υποψήφιος δεν έχει συνδεθεί με αυτόν τον πελάτη."
            },
            CLIENT: {
                TITLE: "Ανατεθέντες πελάτες",
                NO_CLIENT: "Δεν έχουν συνδεθεί πελάτες με αυτόν τον υποψήφιο."
            },
            ADD_CANDIDATE: "Προσθήκη υποψηφίου"
        },
        LAST_CONTACTED_DATE: "Ημερομηνία τελευταίας επικοινωνίας",
        CANDIDATE_BADGES: {
            TITLE: "Σήματα",
            BUTTON: "Αποθήκευση σημάτων"
        }
    },
    COMMUNICATION: {
        DATE: "Ημερομηνία",
        FROM: "Από",
        AATO: "Προς",
        SUBJECT: "Θέμα",
        MESSAGE: "Μήνυμα",
        RE_SEND: "Επαναποστολή",
        CANCEL_SCHEDULE: "Ακύρωση χρονοδιαγράμματος",
        SCHEDULE_TIME: "Προγραμματισμός ώρας"
    },
    PLACEMENT_JOB: {
        SEARCH_TEXT: "Αναζήτηση κατά όνομα αφίσας, τίτλο εργασίας, αναγνωριστικό εργασίας, χρονοδιάγραμμα, πόλη, πολιτεία ή περιγραφή",
        JOB_HIDEN_DESCRIPTION: `Οι εργασίες στην κατάσταση {0} δεν εμφανίζονται στην εργασία
        board από προεπιλογή. Για να ενημερώσετε την κατάσταση μιας εργασίας, κάντε κλικ στο "Επεξεργασία εργασίας".`,
        CLIENT_POSTING_JOB_DESCRIPTION: "Αυτό είναι για τη δημοσίευση μακροπρόθεσμων θέσεων για αυτόν τον πελάτη.",
        ADMIN_POSTING_JOB_DESCRIPTION: "Αυτό είναι για τη δημοσίευση μακροπρόθεσμων θέσεων",
    },
    CONFIRM_DIALOGS: CONFIRM_DIALOGS,
    ERROR_DIALOGS: ERROR_DIALOGS,
    RESULT_DIALOGS: RESULT_DIALOGS,
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/el.js